<template>
  <v-card variant="text" class="primary-surface w-100 overflow-hidden">
    <slot />
  </v-card>
</template>

<script setup>
</script>

<style lang="scss" scoped>
.primary-surface {
  box-shadow: 4px 1px 89px 7px rgba(0, 0, 0, 0.07);
}
.primary-surface, .v-dialog > .v-overlay__content > .v-card.primary-surface {
  border-radius: var(--Radii-Radius-Large, 20px);
}
</style>

<style lang="scss">
.v-dialog > .v-overlay__content > .v-card.primary-surface {
  .v-card-item {
    flex: 1;
    grid-template-rows: max-content;
    overflow: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>